package com.jingfangpai.api.clients

import com.jingfangpai.common.data.response.ApiResponse
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import com.jingfangpai.common.coroutines.applicationDispatcher
import kotlinx.coroutines.launch
import io.ktor.http.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import com.jingfangpai.common.json.json
import kotlin.js.JsName
import io.ktor.content.TextContent
import io.ktor.client.call.body
import com.jingfangpai.api.base.BaseServiceClient
import kotlin.String
import com.jingfangpai.common.orm.mapping.enums.SignSymptomRelationType
import com.jingfangpai.common.orm.mapping.SignSymptom
import com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.SignSymptomRelation

object SignSymptomApiClient :BaseServiceClient() {

	@JsName("findAllCharacteristicsGroupBySymptomId")
	fun findAllCharacteristicsGroupBySymptomId( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.Map<kotlin.String, kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.Map<kotlin.String, kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>>> = httpClient.get {
				    url("/api/signSymptom/findAllCharacteristicsGroupBySymptomId?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getCharacteristics")
	fun getCharacteristics(signSymptomId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"signSymptomId" to "${signSymptomId?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>> = httpClient.get {
				    url("/api/signSymptom/getCharacteristics?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getDetail")
	fun getDetail(id:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomDetail>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"id" to "${id?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomDetail> = httpClient.get {
				    url("/api/signSymptom/getDetail?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getIdNameList")
	fun getIdNameList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.data.model.IdName>> = httpClient.get {
				    url("/api/signSymptom/listIdNames?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getList")
	fun getList( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptom>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptom>> = httpClient.get {
				    url("/api/signSymptom/list?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getNames")
	fun getNames( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomNames>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomNames> = httpClient.get {
				    url("/api/signSymptom/getNames?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getOptions")
	fun getOptions( okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
		val params = ""
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.data.model.CascadedOption<kotlin.String>>> = httpClient.get {
				    url("/api/signSymptom/options?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("getSignSymptomRelations")
	fun getSignSymptomRelations(signSymptomId:kotlin.String,type:com.jingfangpai.common.orm.mapping.enums.SignSymptomRelationType?, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.signSymptom.model.SignSymptomRelationDto>>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			"signSymptomId" to "${signSymptomId?:""}",
			"type" to "${type?:""}",
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<com.jingfangpai.signSymptom.model.SignSymptomRelationDto>> = httpClient.get {
				    url("/api/signSymptomRelation/getRelations?$params")
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("save")
	fun save(signSymptom:com.jingfangpai.common.orm.mapping.SignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptom> = httpClient.post {
				    url("/api/signSymptom/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.SignSymptom.serializer(),signSymptom), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveCharacteristic")
	fun saveCharacteristic(signSymptomCharacteristic:com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic> = httpClient.post {
				    url("/api/signSymptomCharacteristic/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic.serializer(),signSymptomCharacteristic), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}


	@JsName("saveSignSymptomRelation")
	fun saveSignSymptomRelation(relation:com.jingfangpai.common.orm.mapping.SignSymptomRelation, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomRelationDto>) -> Unit, errorCallback: (exception:Throwable) -> Unit){
		launch(applicationDispatcher) {
			val params = listOf<Pair<String,String>>(
			).formUrlEncode()
			try {
				val result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.signSymptom.model.SignSymptomRelationDto> = httpClient.post {
				    url("/api/signSymptomRelation/save?$params")
				    setBody(TextContent(json.encodeToString(com.jingfangpai.common.orm.mapping.SignSymptomRelation.serializer(),relation), io.ktor.http.ContentType.Application.Json))
				}.body()
				okCallback(result)
			}catch (e:Throwable){
				errorCallback(e)
			}
		}
	}

}
